import React, { useEffect, useState } from "react";
import {Link} from 'react-router-dom'
import {Container, Row, Col, Form, Button,Modal, Spinner} from 'react-bootstrap'
import Card from '../../../components/Card'
import { FaTrash } from 'react-icons/fa'; 
import cart from '../../../assets/images/icon/cart.png'
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from "react-i18next";
import productImage from '../../../assets/images/store/product.jpeg';
import { CircularProgress } from "@mui/material";
import { getToken } from "../../../utils/auth";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import validatePhoneNumber from "../../../utils/validatePhoneNumber";
import validateEmail from "../../../utils/validateEmail";
import { Country, State } from 'country-state-city';

const StoreCheckout = () => {
  const [loadingFull, setLoadingFull] = useState(false);
  const [loadingFullGet, setLoadingFullGet] = useState(false);

  const [count, setCount] = useState(1);
  const [count1, setCount1] = useState(1);
  const [count2, setCount2] = useState(1);
  const [count3, setCount3] = useState(1);
  const [show,setShow] = useState('')
  const { t, i18n } = useTranslation();
  const [showModalImage, setShowModalImage] = useState(false);

  const [formData, setFormData] = useState({
    name:'',
    email: '',
    phone: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    type:'Home',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const [loading, setLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [customerID, setCustomerID] = useState();
  const [product, setProduct] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [imageURL, setImageURL] = useState("");
  const [productMessages, setProductMessages] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem('selectedCurrency') || 'INR'
  );
  const [currencySymbol, setCurrencySymbol] = useState(
    localStorage.getItem('currencySymbol') || '₹'
  );
  const handleModalOpen = (image) => {
    setImageURL(image);
    setShowModalImage(true);
  }

  const handleModalClose = () => {
    setImageURL("");
    setShowModalImage(false);
  }

  const [user, setUser] = useState("");

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(response?.data?.data);
      setCustomerID(response.data.data.customerId);
       const countryCode = response?.data?.data?.country || "";
                  const countryInfo = Country.getCountryByCode(countryCode);
                  const countryNameFromList = countryInfo?.name || "";
                  setFormData((prev) => ({ ...prev, country: countryNameFromList }));
      
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  // const handleAddresses = async () => {  
  //   if (!customerID) return; 
  //   setLoadingFullGet(true)
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/customer-addresses/${customerID}`
  //     );
  
  //     setAddresses(response.data);
  //     setSelectedAddress(response.data[0]);
  //   } catch (error) {
  //     console.error('Failed fetching address', error);
  //   } finally{
  //     setLoadingFullGet(false)
  //   }
  // };
  const handleAddresses = async () => {
  if (!customerID) return;

  setLoadingFullGet(true);

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/customer-addresses/${customerID}`
    );

    const addresses = response.data || [];

    setAddresses(addresses);
    setSelectedAddress(addresses.length > 0 ? addresses[0] : null);

  } catch (error) {
    if (error.response?.status === 404) {
      setAddresses([]);
      setSelectedAddress(null);
    } else {
      console.error('Failed fetching address', error);
    }
  } finally {
    setLoadingFullGet(false);
  }
};


  const deleteAddress = async (id) => {  
    try {
      setLoadingFull(true)
      const response = await axios.delete(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/customer-addresses/${id}`
      );
    } catch (error) {
      console.error('Failed deleting address', error);
    } finally{
      setLoadingFull(false)
            handleAddresses();

    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    handleAddresses();
  }, [customerID]);

  const handleSelectAddress = () => {
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);

  const selectAddress = (address, index) => {
    setSelectedAddress(address);
    setSelectedIndex(index); // Update the selected address index
    setShowModal(false); // Close modal after selecting
  };

  const fetchProducts = async () => {
    const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/${customerID}?wmc-currency=${selectedCurrency}`;
    const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=';

    try {
      setLoadingFullGet(true)
        const response = await axios.get(url, {
            headers: {
                'Authorization': authHeader,
            },
        });
        if (!response.data.empty) {
            const items = response.data.items;
            setProduct(response.data.items);

            setCartItems(items);

            const total = items.reduce((sum, item)=> sum + parseFloat(item.subtotal), 0)
            setTotalPrice(total); 

            const quantity = items.reduce((sum, item)=> sum + parseFloat(item.quantity), 0);
            setTotalQuantity(quantity);
        } else {
            setProduct([]);
            setTotalPrice(0);
            setTotalQuantity(0);
        }
    } catch (error) {
        console.error("Error fetching cart:", error);
    } finally {
        setLoading(false);
        setLoadingFullGet(false)

    }
};


const handleSubmit = async (e) => {
  e.preventDefault();

    if (
    !formData.name ||
    !formData.email ||
    !formData.phone ||
    !formData.addressLine1 ||
    !formData.city ||
    !formData.state ||
    !formData.pincode ||
    !formData.country ||
    !formData.type
  ) {
    toast.error("Please fill all required fields.");
    return;
  }
    setLoadingFull(true)

  if (!(await validateEmail(formData.email))) {
    toast.error("Invalid Email");
        setLoadingFull(false)
    return;
  }

  if (!(await validatePhoneNumber(formData.phone))) {
    toast.error("Invalid phone number.");
        setLoadingFull(false)
    return;
  }

  try {
    setLoadingFull(true)

    const response = await axios.post(
      `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/customer-addresses`,
      {
        user_id: customerID,
        name:formData.name,
        email:formData.email,
        phone_number:formData.phone,
        address_line_1: formData.addressLine1,
        address_line_2: formData.addressLine2,
        city: formData.city,
        state: formData.state,
        postal_code: formData.pincode,
        country: formData.country,
        type: formData.type
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A='
        }
      }
    );
    handleAddresses();
    toast.success(response?.data?.message || "Address added successfully");
    setFormData({
        name:'',
        email: '',
        phone: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        type:'Home',
    })
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to add address");
    console.error('Failed adding address:', error);
  } finally{
    setLoadingFull(false)

  }
};

// const handleUpdateQuantity = async (productid, newQuantity) => {
//     const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/update?user_id=${customerID}&product_id=${productid}&quantity=${newQuantity}`;
//     const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYwqBRTm9w';
  
//     try {
//       const response = await axios.put(url, {}, {
//         headers: {
//           'Authorization': authHeader,
//         },
//       });
//       console.log('Product updated successfully', response.data);
//       fetchProducts();
//     } catch (error) {
//       console.error('Error updating product quantity', error);
//     }
//   };

const handleUpdateQuantity = async (productid, newQuantity) => {
 

  const productItem = product.find((item) => item.product_id === productid);

    // SPECIAL QRC RULE (ABSOLUTE)
  if (productItem?.qrc_type === "special") {
    setProductMessages((prev) => ({
      ...prev,
      [productid]: "This is a Special QRC. Quantity cannot be increased.",
    }));
    return;
  }

  // LOST & FOUND STOCK CHECK
  if (productItem?.qrc_type === "lost-and-found" && newQuantity > productItem.qrc_available) {
    setProductMessages((prevMessages) => ({
      ...prevMessages,
      [productid]: `Quantity cannot exceed available stock (${productItem.qrc_available}) for "${productItem.product_name}".`,
    }));
    return;
  }

  // Clear any existing message for the product if quantity is valid
  setProductMessages((prevMessages) => ({
    ...prevMessages,
    [productid]: "",
  }));

  const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/update?user_id=${customerID}&product_id=${productid}&quantity=${newQuantity}`;
  const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYwqBRTm9w';

  try {
    setLoadingFull(true)
      const response = await axios.put(url, {}, {
          headers: {
              'Authorization': authHeader,
          },
      });
      fetchProducts();
  } catch (error) {
      console.error('Error updating product quantity', error);
  } finally{
    setLoadingFull(false)
  }
};



//  console.log("totalPrice",totalPrice);
const handleRemoveItem = async (productid) => {
    try {
      setLoadingFull(true)
      const response = await axios.delete(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/remove?user_id=${customerID}&product_id=${productid}`
      );
      fetchProducts();
    } catch (error) {
      console.error('Failed deleting product', error);
    } finally{
      setLoadingFull(false)
    }
  };

useEffect(() => {
    if(customerID){
    fetchProducts();
    }
}, [customerID]);

const handleCreateOrder = async () => {
    if (!selectedAddress || Object.keys(selectedAddress).length === 0) {
        toast.error("Address not selected!");
        return;
    }

    if (cartItems.length === 0) {
        toast.error("Cart is empty!");
        return;
    }

    const orderData = {
      payment_method: "bacs",
      payment_method_title: "Direct Bank Transfer",
      set_paid: false,
      currency:selectedCurrency,
      customer_id: customerID,
      billing: {
        first_name: selectedAddress.name,
        // last_name: "Last",
        address_1: selectedAddress.address_line_1,
        address_2: selectedAddress.address_line_2,
        city: selectedAddress.city,
        state: selectedAddress.state,
        postcode: selectedAddress.postal_code,
        country: selectedAddress.country,
        email: selectedAddress.email,
        phone: selectedAddress.phone_number
      },
      shipping: {
        first_name: selectedAddress.name,
        // last_name: "Last",
        address_1: selectedAddress.address_line_1,
        address_2: selectedAddress.address_line_2,
        city: selectedAddress.city,
        state: selectedAddress.state,
        postcode: selectedAddress.postal_code,
        country: selectedAddress.country
      },
    //   line_items: cartItems?.map(item => ({
    //     product_id: parseInt(item?.product_id),
    //     quantity: parseInt(item?.quantity),
    // })),
    line_items: cartItems?.map(item => {
      const lineItem = {
        product_id: parseInt(item?.product_id),
        quantity: parseInt(item?.quantity),
      };
      if (item?.uploaded_image_id) {
        lineItem.image_id = parseInt(item.uploaded_image_id);
      }
      return lineItem;
    }),
      shipping_lines: [
        {
          method_id: "flat_rate",
          method_title: "Flat Rate",
          total: "0.00"
        }
      ]
    };

    try {
      setLoadingFull(true)

      const response = await axios.post(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/orders`,
        orderData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A='
          }
        }
      );
      await emptyCart(customerID);
      await initiatePayment(response?.data?.id);
      toast.success('Order created successfully!');
      setCartItems([]);
    } catch (error) {
      toast.error('Failed to create the order'); 
      console.error('Order Creation Error:', error);
    } finally{
      setLoadingFull(false)

    }
  };

  const initiatePayment = async (orderid) => {
   
    try {
      const payload = {
          "amount": parseFloat(totalPrice || '0'),
          "currency": selectedCurrency,
          "paymentFor": "order",
          "orderId": orderid
      };
      const token = getToken();
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/payment/initiate-payment`, payload, {
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      emptyCart(customerID)
      const paymentUrl = response.data.url;
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        toast.error('Failed to retrieve payment URL.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      toast.error(error?.response?.data?.message || 'Failed to initiate payment. Please try again.');
    }
  };

const emptyCart = async (customerID) => {
    const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/empty/${customerID}`;
    const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYwqBRTm9w'; 

    try {
      setLoadingFull(true)
        const response = await axios.delete(url, {
            headers: {
                'Authorization': authHeader
            }
        });
        // toast.success('Cart emptied successfully!');
        fetchProducts();
        setShow('show');
    } catch (error) {
        // toast.error('Failed to empty the cart');
        console.error('Cart Empty Error:', error);
    } finally{
      setLoadingFull(false)
    }
};

const handlePhoneChange = (phone, field) => {
  setFormData((prev) => ({
    ...prev,
    [field]: phone,
  }));
};
const getCountryCodeByName = (countryName) => {
  const country = Country.getAllCountries().find(
    (c) => c.name === countryName
  );
  return country?.isoCode || "";
};
    return (
    <>
    {loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
    {loadingFullGet && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
        <>
        <Toaster position="top-right" reverseOrder={false}/>
        <div id="content-page" className="content-page">
                    <Container>
                        <>
                            <div id="cart" className={`cart-card-block p-0 col-12 ${show === 'address' || show === 'payment' ? '' :'show' }`}>
                                <Row className="align-item-center">
                                    <Col lg="8">
                                        <Card>
                                            <Card.Header className=" d-flex justify-content-between iq-border-bottom mb-0">
                                                <div className="header-title">
                                                    <h4 className="card-title">{t('shopping_cart')}</h4>
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
        {loading ? (
            <div className="text-center my-5">
            <Spinner animation="border" variant="primary" />
            <p>{t('loading_cart_items')}</p>
          </div>
        ) : product.length > 0 ? (
            product.map((item) => {
                const isSpecial = item.qrc_type === "special";
              return(
                <div className="checkout-product" key={item.product_id} style={{marginBottom:"10px"}}>
                    <div style={{ display:"flex", flexWrap:"wrap"}} className="align-items-center">
                        <Col sm="2">
                            <span className="checkout-product-img">
                                <Link to="#">
                                    <img
                                        style={{ width: "80px", height: "80px" }}
                                        className="img-fluid rounded d-none d-lg-flex"
                                        src={item.image_url ? item.image_url : productImage}
                                        alt={item.product_name}
                                    />
                                </Link>
                            </span>
                        </Col>
                         <Col sm="4" style={{flex:1}}>
          <div className="checkout-product-details">
            <h5>{item?.product_name}</h5>
            {item?.uploaded_image && (
              <div>
                <Link
                  to="#"
                  className="text-primary"
                  onClick={()=>handleModalOpen(item?.uploaded_image)}
                >
                  {t('view_uploaded_image')}
                </Link>
              </div>
            )}
          </div>
                        </Col>
                        <Col sm="6" style={{flex:1}}>
                            <div style={{ display:"flex", flexWrap:"wrap"}}>
                                <Col sm="10" className="col-10" >
                                    <div className="align-items-center" style={{display:"flex", flexWrap:"wrap"}}>
                                        <Col sm="7" md="6" className="col-8">
                                            <div className="quantity buttons_added">
                                                <input
                                                    type="button"
                                                    defaultValue="-"
                                                    className="minus h5"
                                                    // disabled={isSpecial}
          onClick={() => {
            if (isSpecial) {
              setProductMessages((prev) => ({
                ...prev,
                [item.product_id]:
                  "This is a Special QRC. Quantity cannot be increased.",
              }));
              return;
            }
            handleUpdateQuantity(
              item.product_id,
              Math.max(1, item.quantity - 1)
            );
          }}
                                                    // onClick={() =>
                                                    //     handleUpdateQuantity(
                                                    //         item.product_id,
                                                    //         Math.max(1, parseInt(item.quantity) - 1)
                                                    //     )
                                                    // }
                                                />
                                                <input
                                                    type="button"
                                                    value={item.quantity}
                                                    title="Qty"
                                                    className="input-text qty text ms-1"
                                                />
                                                <input
                                                    type="button"
                                                    defaultValue="+"
                                                    className="plus h5"
                                                    // disabled={isSpecial}
          onClick={() => {
            if (isSpecial) {
              setProductMessages((prev) => ({
                ...prev,
                [item.product_id]:
                  "This is a Special QRC. Quantity cannot be increased.",
              }));
              return;
            }
            handleUpdateQuantity(item.product_id, item.quantity + 1);
          }}
                                                    // onClick={() =>
                                                    //     handleUpdateQuantity(
                                                    //         item.product_id,
                                                    //         parseInt(item.quantity) + 1
                                                    //     )
                                                    // }
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="5" md="6" className="col-4" style={{display:"flex", whiteSpace:"nowrap", textAlign:"center", justifyContent:"center"}}>
                                            <span className="product-price">{currencySymbol} {parseFloat(item?.subtotal || '0').toFixed(2)}</span>
                                        </Col>
                                    </div>
                                </Col>
                                <Col
  sm="2"
  className="col-2"
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingInline:"10px"
  }}
>
  <Link
    to="#"
    className="text-dark material-symbols-outlined"
    onClick={() => handleRemoveItem(item.product_id)}
  >
    delete
  </Link>
</Col>

                            </div>
                        </Col>
                    </div>
                    <div style={{ display: "flex", justifyContent: "right", color: "red" }}>
        {productMessages[item.product_id] && productMessages[item.product_id]}
      </div>    
                  </div>
            )})
        ) : (
            <p>{t('your_cart_is_empty')}</p>
        )}
    </Card.Body>
    
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card>
                                            <Card.Body>
                                                <p><b>{t('order_details')}</b></p>
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span>{t('cart')}({totalQuantity})</span>
                                                    <span>{currencySymbol} {parseFloat(totalPrice || '0').toFixed(2)}</span>
                                                </div>
                                                <div className="d-flex justify-content-between mb-4">
                                                    <span>{t('delivery_charges')}</span>
                                                    <span className="text-success">{t('free')}</span>
                                                </div>
                                                <hr/>
                                                <div className="d-flex justify-content-between mb-4">
                                                    <span className="text-dark"><strong>{t('total')}</strong></span>
                                                    <span className="text-dark"><strong>{currencySymbol} {parseFloat(totalPrice || '0').toFixed(2)}</strong></span>
                                                </div>
                                                <Link id="place-order" to="#" className="btn btn-primary d-block mt-3 next" onClick={() => setShow('address')}>{t('continue')}</Link>
                                            </Card.Body>
                                        </Card>
                                        <Card>
                                            <Card.Body  className="card-body p-0 iq-checkout-policy">
                                                <ul className="p-0 m-0">
                                                    <li className="d-flex align-items-center">
                                                        <div className="iq-checkout-icon">
                                                            <i className="material-symbols-outlined">check_box</i>
                                                        </div>
                                                        <h6>{t('security_policy')}</h6>
                                                    </li>
                                                    <li className="d-flex align-items-center">
                                                        <div className="iq-checkout-icon">
                                                            <i className="material-symbols-outlined">local_shipping</i>
                                                        </div>
                                                        <h6>{t('delivery_policy')}</h6>
                                                    </li>
                                                    {/* <li className="d-flex align-items-center">
                                                        <div className="iq-checkout-icon">
                                                            <i className="material-symbols-outlined">keyboard_return</i>
                                                        </div>
                                                        <h6>{t('return_policy')}</h6>
                                                    </li> */}
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                            <div id="address" className={`cart-card-block p-0 col-12 ${show === 'address' ? 'show' : ''}`}>
                                <Row className="align-item-center">
        <Col lg="8">
      <Card>
        <Card.Header className="d-flex justify-content-between">
          <div className="header-title">
            <h4 className="card-title">{t('add_new_address')}</h4>
          </div>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mt-3">

              <Col md="12">
                <Form.Group className="form-group">
                  <Form.Label>{t('name_label')}: *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col> 
               <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('email_label')}: *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col> 
              <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('mobile_number')}: *</Form.Label>
                  {/* <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  /> */}
                    <PhoneInput
                      country={(user?.country || "us").toLowerCase()} 
                      value={formData.phone}
                      onChange={(phone) => handlePhoneChange(phone, "phone")}
                      inputStyle={{ width: "100%", paddingBlock:"20px" }}
                      required
                    />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('address')}: *</Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine1"
                    value={formData.addressLine1}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('address_line_2')}:</Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine2"
                    value={formData.addressLine2}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
               <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('country')}: *</Form.Label>
                  {/* <Form.Control
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    required
                  /> */}
              <Form.Select
                        name="country"
                        value={formData.country}
                        onChange={(e) => {
                          const selectedCountryName = e.target.value;
                          setFormData({
                            ...formData,
                            country: selectedCountryName,
                            state: "",
                          });
                        }}
                        className="mb-0 py-2"
                        required
                      >
                        <option value="">Select Country</option>
                        {Country.getAllCountries().map((country) => (
                          <option key={country.isoCode} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </Form.Select>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('state')}: *</Form.Label>
                  {/* <Form.Control
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    required
                  /> */}
                   <Form.Select
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            className="mb-0 py-2"
                            required
                            disabled={!formData.country}
                          >
                            <option value="">Select State</option>
                            {formData.country &&
                              State.getStatesOfCountry(getCountryCodeByName(formData.country)).map(
                                (state) => (
                                  <option key={state.isoCode} value={state.name}>
                                    {state.name}
                                  </option>
                                )
                              )}
                          </Form.Select>
                </Form.Group>
              </Col>
               <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('city')}: *</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="form-group">
                  <Form.Label>{t('pincode')}: *</Form.Label>
                  <Form.Control
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="12">
  <Form.Group className="form-group">
    <Form.Label>{t('address_type')}: *</Form.Label>
    <Form.Control
      as="select"
      name="type"
      value={formData.type}
      onChange={handleInputChange}
      required
    >
      {/* <option value="">Select a country</option> */}
      <option value="Home">{t('home')}</option>
      <option value="Work">{t('work')}</option>
    </Form.Control>
  </Form.Group>
</Col>

              <Col md="6">
                <Button id="saveAndDeliver" type="submit" variant="primary">
                  {t('save_and_deliver_here')}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Col>

                                    <Col lg="4">
                                    <Card>
  <Card.Body>
    {addresses && addresses.length > 0  ? (
      <>
        {selectedAddress?.name && <h4 className="mb-2">{selectedAddress.name}</h4>}

        <div className="shipping-address">
          {/* Address Line 1 and Address Line 2 */}
          {selectedAddress?.address_line_1 && (
            <p className="mb-0">
              {selectedAddress.address_line_1}
              {selectedAddress?.address_line_2 && `, ${selectedAddress.address_line_2}`}
            </p>
          )}

          {/* City, State, Country, Postal Code */}
          {(selectedAddress?.city || selectedAddress?.state || selectedAddress?.country || selectedAddress?.postal_code) && (
            <p>
              {selectedAddress?.city && `${selectedAddress.city}, `}
              {selectedAddress?.state && `${selectedAddress.state}, `}
              {selectedAddress?.country && `${selectedAddress.country}`}
              {selectedAddress?.postal_code && ` - ${selectedAddress.postal_code}`}
            </p>
          )}

          {selectedAddress?.email && <div>{selectedAddress.email}</div>}
          {/* Phone Number */}
          {selectedAddress?.phone_number && <div>{selectedAddress.phone_number}</div>}
        </div>

        <div style={{ display: "flex", justifyContent: "right" }}>
          {addresses && addresses.length > 0 && (
            <Button onClick={handleSelectAddress} variant="primary">
              {t('select_address')}
            </Button>
          )}
        </div>
        <hr />
        <Button
          id="deliver-address"
          style={{width:"100%"}}
          className="btn btn-primary d-block mt-1 next "
        //   onClick={() => setShow('payment')}
          onClick={handleCreateOrder}
        >
          {t('place_order')}
        </Button>
      </>
    ) : (
      <p>{t('no_address_available')}</p> // This will now display if selectedAddress is null or undefined
    )}
  </Card.Body>
</Card>


                                    </Col>
            
                                </Row>
                            </div>
                            <div id="payment" className={`cart-card-block p-0 col-12 ${show === 'payment' ? 'show' : ''}`}>
                                <Row className="align-item-center">
                                    <Col lg="8">
                                        <Card>
                                            <Card.Header className="d-flex justify-content-between">
                                                <div className="header-title">
                                                    <h4 className="card-title">{t('payment_options')}</h4>
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <img src={cart} alt="" height="40" width="50"/>
                                                        <span>{t('us_unlocked_debit_card')} 12XX XXXX XXXX 0000</span>
                                                    </div>
                                                    <span>Nik John</span>
                                                    <span>28/2020</span>
                                                </div>
                                                <Form className="mt-3">
                                                    <div className="d-flex align-items-center">
                                                        <span>{t('enter_cvv')}: </span>
                                                        <div className="cvv-input ms-3 me-3">
                                                            <Form.Control type="text" required/> 
                                                        </div>
                                                        <Button type="submit" className="primary">{t('continue')}</Button>
                                                    </div>
                                                </Form>
                                                <hr/>
                                                <div className="card-lists">
                                                    <Form.Group className="form-group">
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input  type="radio" id="credit" name="customRadio"/>
                                                            <Form.Check.Label  htmlFor="credit"> {t('credit_debit_atm_card')}</Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input  type="radio" id="netbaking" name="customRadio"/>
                                                            <Form.Check.Label  htmlFor="netbaking"> {t('net_banking')}</Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input  type="radio" id="emi" name="emi"/>
                                                            <Form.Check.Label  htmlFor="emi"> {t('emi_easy_installment')}</Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input  type="radio" id="cod" name="cod"/>
                                                            <Form.Check.Label  htmlFor="cod"> {t('cash_on_delivery')}</Form.Check.Label>
                                                        </Form.Check>
                                                    </Form.Group>
                                                </div>
                                                <hr/>
                                                <div className="add-card">
                                                    <Link to="#"><span><i className="ri-add-box-line me-2 h5"></i>{t('add_gift_card')}</span></Link>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card>
                                            <Card.Body>
                                                <h4 className="mb-2">{t('price_details')}</h4>
                                                <div className="d-flex justify-content-between">
                                                    <span>{t('price')} 3 {t('items')}</span>
                                                    <span><strong>$1000.00</strong></span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span>{t('delivery_charges')}</span>
                                                    <span className="text-success">Free</span>
                                                </div>
                                                <hr/>
                                                <div className="d-flex justify-content-between">
                                                    <span>{t('amount_payable')}</span>
                                                    <span><strong>$1000.00</strong></span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </>
                    </Container>
                </div>
        </>
        {showModal && (
        <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
          width: '60vw',
          minWidth:"350px",
          maxHeight: '60vh',
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        <h2>{t('select_an_address')}</h2>
        <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} onClick={closeModal}>
          X
        </div>

        <div>
  {addresses.length === 0 ? (
    <p style={{ textAlign: 'center', color: '#888' }}>
      {t('no_address_available')}
    </p>
  ) : (
    addresses.map((address, index) => (
      <div
        key={index}
        style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}
      >
        {/* Radio button */}
        <input
          type="radio"
          name="address"
          checked={selectedIndex === index}
          onChange={() => selectAddress(address, index)}
          style={{ marginRight: '10px' }}
        />

        {/* Address details */}
        <div style={{ flex: 1 }}>
          <p>
            <strong>{address.name}</strong>
            <br />
            {address.address_line_1}
            {address.address_line_2 && `, ${address.address_line_2}`}
            <br />
            {address.city}, {address.state}, {address.country} - {address.postal_code}
            <br />
            {address.email}
            <br />
            {address.phone_number}
          </p>
        </div>

        {/* Delete icon */}
        <FaTrash
          style={{ cursor: 'pointer', marginLeft: '10px' }}
          onClick={() => deleteAddress(address?.id)}
        />
      </div>
    ))
  )}
</div>

      </div>
    </div>
    )}
     <Modal show={showModalImage} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('uploaded_image')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{display:"flex"}}>
          {imageURL ? (
            <img
              src={imageURL}
              alt="Uploaded"
              style={{ display:"flex",marginInline:"auto", maxWidth:"300px", width: '100%', height: 'auto', borderRadius: '8px' }}
            />
          ) : (
            <p>{t('no_image_uploaded')}</p>
          )}
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
  
  <Button variant="secondary" onClick={handleModalClose}>
  {t('close')}
  </Button>

</Modal.Footer>

      </Modal>
        </>
    )
}
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};
export default StoreCheckout